// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-form-pro中使用,该组件不要删除


import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { EmopFormData } from '../../common/EmopFormData';

@Component({
  selector: 'emop-form',
  templateUrl: './emop-form.component.html',
  styleUrls: ['./emop-form.component.scss']
})
export class EmopFormComponent implements OnInit {

  @Input() EmopFormData: EmopFormData;
  @Input() col: number = 2;
  @Input() hasFeedback: boolean = false;
  @Input() layout: 'horizontal' | 'vertical' | 'inline' = 'horizontal';
  @Output() valueChange = new EventEmitter();

  constructor() { }
  ngOnChanges(changes): void {
  }
  ngOnInit(): void {
    if (!this.EmopFormData) return console.error('请传入EmopFormData');
    if (this.EmopFormData.value) {
      if (new Set(this.EmopFormData.value.map(item => item.key)).size !== this.EmopFormData.value.length) {
        console.error('传入的key属性值必须唯一, 否则会造成不必要的数据问题');
      }
    }
  }
  /**
   * 表单后方的按钮
   * @param data
   * @param index
   */
  afterBtn(data) {
    const target = this.EmopFormData.tempData.find(item => item.key === data.key);
    target.afterBtn.fn(data);
  }
  /**
   * 输入事件回调
   */
  changeFn(data) {
    let target = this.EmopFormData.tempData.find(item => item.key === data.key);
    if (target?.changeFn) target.changeFn(data.value);

    // 输入时取消校验
    target = this.EmopFormData.value.find(item => item.key === data.key);
    if (target) target.validateStatus = 'success';
  }
  openChange(data) {
    const target = this.EmopFormData.tempData.find(item => item.key === data.data.key);
    if (target?.openChange?.fn) target.openChange.fn(data);
  }
  btnClick(key: string) {
    const target = this.EmopFormData.tempData.find(item => item.key === key);
    target.btn.fn(target);
  }
}
